module.exports = __webpack_public_path__ + "img/place-icon.aaaeae20.png";